!(function($, window) {
    // ParsleyConfig definition if not already set
    window.ParsleyConfig = window.ParsleyConfig || {};
    window.ParsleyConfig.i18n = window.ParsleyConfig.i18n || {};

    // Define then the messages
    window.ParsleyConfig.i18n.translatedMessages = $.extend(window.ParsleyConfig.i18n.translatedMessages|| {}, {
        defaultMessage: bq.messages.global.parsley.defaultMessage,
        type: {
            email:        bq.messages.global.parsley.type.email,
            url:          bq.messages.global.parsley.type.url,
            number:       bq.messages.global.parsley.type.number,
            integer:      bq.messages.global.parsley.type.integer,
            digits:       bq.messages.global.parsley.type.digits,
            alphanum:     bq.messages.global.parsley.type.alphanum
        },
        notblank:         bq.messages.global.parsley.notblank,
        required:         bq.messages.global.parsley.required,
        pattern:          bq.messages.global.parsley.pattern,
        min:              bq.messages.global.parsley.min,
        max:              bq.messages.global.parsley.max,
        range:            bq.messages.global.parsley.range,
        minlength:        bq.messages.global.parsley.minlength,
        maxlength:        bq.messages.global.parsley.maxlength,
        length:           bq.messages.global.parsley.length,
        mincheck:         bq.messages.global.parsley.mincheck,
        maxcheck:         bq.messages.global.parsley.maxcheck,
        check:            bq.messages.global.parsley.maxcheck.check,
        equalto:          bq.messages.global.parsley.maxcheck.equalto,
        onefieldrequired: bq.messages.global.parsley.onefieldrequired,
        notequalto:       bq.messages.global.parsley.notequalto,
        price:            bq.messages.global.priceValidation,
        loginid:          bq.messages.global.parsley.loginid,
        netamount:        bq.messages.global.parsley.netamount,
        minnetamount:     bq.messages.global.parsley.minnetamount,
        greaterthanzero:  bq.messages.global.parsley.greaterthanzero,
        floatnumber:      bq.messages.global.parsley.floatnumber,
        qtyinput:         bq.messages.global.parsley.qtyinput,
        expirationdate:   bq.messages.global.parsley.invalidexpirationdate
    });

    // If file is loaded after Parsley main file, auto-load locale
    if ('undefined' !== typeof window.ParsleyValidator)
        window.ParsleyValidator.addCatalog(bq.config.locale, window.ParsleyConfig.i18n.translatedMessages, true);
})(jQuery, window);